<template>
  <div id="register">
    <section id="registerBenefit">
      <div class="container">
        <div class="row">
          <div class="col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-lg-4 col-md-6 col-sm-8 col-xs-12">
            <h1 class="title">회원가입 시 혜택</h1>
            <h6 class="description">태양광 시공사/제조사 등 기업만 가입 및 이용이 가능합니다!</h6>
            <ul class="benefit-list">
              <li>
                <div class="number">01</div>
                <div class="desc">자동화된<br>사업성검토</div>
              </li>
              <li>
                <div class="number">02</div>
                <div class="desc">모듈˙인버터<br>특가구매</div>
              </li>
              <li>
                <div class="number">03</div>
                <div class="desc">보험료<br>20% 할인</div>
              </li>
              <li>
                <div class="number">04</div>
                <div class="desc">금융/사업개발<br>지원</div>
              </li>
            </ul>
            <div class="benefit-box">
              <object type="image/svg+xml"
                      :data="iconPresent"
                      width="28px"
                      height="28px"
              >
                현재 사용 중인 브라우저는 해당 이미지를 지원하지 않습니다.
              </object>
              <p>가입시, 모든 서비스를 1개월 무료로 <br>이용할 수 있는 쿠폰을 드립니다.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="registerForm">
      <div class="container">
        <div class="row">
          <div class="col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-lg-4 col-md-6 col-sm-8 col-xs-12">
            <form class="register-form" @submit.prevent="onSubmit">
              <div v-show="isFirstForm">
                <div class="form-group">
                  <div class="col-xs-12">
                    <label>아이디 <small class="require-tag">*</small></label>
                  </div>
                  <div class="col-xs-12">
                    <input type="text"
                           ref="inputId"
                           :class="['hz-input-default', 'hz-input-lg', {'is-invalid': isDuplicatedId}]"
                           maxlength="20"
                           autocomplete="off"
                           data-vv-name="id"
                           v-validate="{required: true, min: 5, max: 15, regex: '^[0-9a-zA-Z_-]+$'}"
                           v-model="data.username"
                           placeholder="아이디를 입력해주세요.">
                    <p class="is-invalid-text">{{ errors.first('id') }}</p>
                    <p class="is-invalid-text" v-if="isDuplicatedId">중복된 아이디입니다.</p>
                  </div>
                </div>
                <div class="form-group margin-bottom-32">
                  <div class="col-xs-12">
                    <label>비밀번호 <small class="require-tag">*</small></label>
                  </div>
                  <div class="col-xs-12">
                    <input type="password" ref="password"
                           class="hz-input-default hz-input-lg"
                           maxlength="15"
                           autocomplete="off"
                           data-vv-name="password"
                           v-validate="{required: true, min: 8, max: 15, regex: '^(?=.*[a-z]|.*[A-Z])(?=.*\\d)[a-zA-Z\\d]'}"
                           v-model="data['password']"
                           placeholder="비밀번호를 입력해주세요.">
                    <p v-if="errors.first('password')" class="is-invalid-text">{{ errors.first('password') }}</p>
                    <input type="password"
                           class="hz-input-default hz-input-lg margin-top-8"
                           maxlength="15"
                           autocomplete="off"
                           data-vv-name="password2"
                           v-validate="{required: true, confirmed: 'password'}"
                           v-model="data['password2']"
                           placeholder="비밀번호를 확인해주세요.">
                    <p class="is-invalid-text">{{ errors.first('password2') }}</p>
                    <p class="explain-text">문자와 숫자조합으로 8자 이상 15자 이하로 입력해주세요.</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-xs-12">
                    <label>담당자명 <small class="require-tag">*</small></label>
                  </div>
                  <div class="col-xs-12">
                    <input type="text"
                           class="hz-input-default hz-input-lg"
                           maxlength="20"
                           data-vv-name="name"
                           v-validate="{required: true}"
                           v-model="data['pic_name']"
                           placeholder="담당자명을 입력해주세요.">
                    <p class="is-invalid-text">{{ errors.first('name') }}</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-xs-12">
                    <label>담당자 연락처 <small class="require-tag">*</small></label>
                  </div>
                  <div class="col-xs-12">
                    <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('contact')}]"
                                 data-vv-name="contact"
                                 v-validate="{required: true, min:9, max:16}"
                                 v-model="data['pic_contact']"
                                 :placeholder="'담당자 연락처를 입력해주세요.'"
                    >
                    </input-phone>
                    <p class="is-invalid-text">{{ errors.first('contact') }}</p>
                  </div>
                </div>
                <div class="form-group margin-bottom-32">
                  <div class="col-xs-12">
                    <label>담당자 이메일 <small class="require-tag">*</small></label>
                  </div>
                  <div class="col-xs-12">
                    <input type="text"
                           class="hz-input-default hz-input-lg"
                           maxlength="50"
                           data-vv-name="email"
                           v-validate="{required: true, email: true}"
                           v-model="data['pic_email']"
                           placeholder="담당자 이메일을 입력해주세요.">
                    <p class="is-invalid-text">{{ errors.first('email') }}</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-xs-12">
                    <label>사업자 등록번호 <small class="require-tag">*</small></label>
                  </div>
                  <div class="col-xs-12">
                    <input type="text"
                           :class="['hz-input-default', 'hz-input-lg', {'is-invalid': isDuplicatedCrn}]"
                           maxlength="20"
                           data-vv-name="crn"
                           v-validate="{required: true, min: 10, max: 12, regex: '^[0-9]{3}-[0-9]{2}-[0-9]{5}'}"
                           v-model="data.crn"
                           placeholder="예) 000-00-00000"
                           v-mask="'###-##-#####'">
                    <p class="is-invalid-text">{{ errors.first('crn') }}</p>
                    <p class="is-invalid-text" v-if="isDuplicatedCrn">
                      중복된 사업자 등록번호입니다.
                      <router-link :to="{name: 'contact'}">문의하기</router-link>
                    </p>
                  </div>
                </div>
                <div class="form-group margin-bottom-40">
                  <div class="col-xs-12">
                    <label>사업자등록증</label>
                  </div>
                  <div class="col-xs-12">
                    <input-file :autoUpload="true"
                                :options="fileUploadOption"
                                :saveUrl="fileSaveUrl + '?category=license_file'"
                                :removeUrl="fileRemoveUrl"
                                v-model="data['license_file']"></input-file>
                    <p class="explain-text">pdf, doc, jpg, png 파일(5MB이하)로 업로드해주세요.</p>
                  </div>
                </div>
              </div>
              <div v-show="!isFirstForm">
                <div class="form-group margin-bottom-32">
                  <div class="col-xs-12">
                    <label>회사명 <small class="require-tag">*</small></label>
                  </div>
                  <div class="col-xs-12">
                    <input type="text"
                           class="hz-input-default hz-input-lg"
                           maxlength="30"
                           data-vv-name="company"
                           v-validate="{required: true, max: 30}"
                           v-model="data.name"
                           placeholder="회사명을 입력해주세요.">
                    <p class="is-invalid-text">{{ errors.first('company') }}</p>
                  </div>
                </div>
                <div class="form-group margin-bottom-32" style="overflow: hidden;">
                  <div class="col-xs-12">
                    <label>회사주소 <small class="require-tag">*</small></label>
                  </div>
                  <div class="col-xs-12">
                    <input-address type="text"
                                   :class="['col-xs-12', 'hz-address-default', 'padding-0', {'is-invalid': errors.first('address')}]"
                                   data-vv-name="address"
                                   v-validate="{required: true, max: 255}"
                                   v-model="data.address"
                                   placeholder="회사주소를 입력해주세요.">
                    </input-address>
                    <input type="text"
                           class="hz-input-default hz-input-lg margin-top-8"
                           maxlength="100"
                           v-model="data.rest_address"
                           placeholder="상세주소">
                    <p class="is-invalid-text">{{ errors.first('address') }}</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-xs-12">
                    <label>회사연락처 <small class="require-tag">*</small></label>
                  </div>
                  <div class="col-xs-12">
                    <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('company_contact')}]"
                                 data-vv-name="company_contact"
                                 v-validate="{required: true, min:9, max:16}"
                                 v-model="data.contact"
                                 :placeholder="'회사연락처를 입력해주세요.'"
                    >
                    </input-phone>
                    <p class="is-invalid-text">{{ errors.first('company_contact') }}</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-xs-12">
                    <label>팩스</label>
                  </div>
                  <div class="col-xs-12">
                    <input-phone name="fax"
                                 class="hz-input-default hz-input-lg"
                                 v-model="data['fax']"
                                 :placeholder="'팩스번호를 입력해주세요.'"
                    >
                    </input-phone>
                  </div>
                </div>
                <div class="form-group margin-bottom-40">
                  <div class="col-xs-12">
                    <label>전기공사업 면허</label>
                  </div>
                  <div class="col-xs-12">
                    <label class="hz-radio-btn radio-inline" style="margin-right: 16px;">
                      <input type="radio"
                             :value="false"
                             v-model="data['electronic_license']">없음
                    </label>
                    <label class="hz-radio-btn radio-inline">
                      <input type="radio"
                             :value="true"
                             v-model="data['electronic_license']">있음
                    </label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-xs-12">
                    <label>세금계산서 발행 이메일</label>
                  </div>
                  <div class="col-xs-12">
                    <input type="text"
                           class="hz-input-default hz-input-lg"
                           maxlength="50"
                           data-vv-name="tax_email"
                           v-validate="{email: true}"
                           v-model="data['tax_email']"
                           placeholder="세금계산서 발행 이메일을 입력해주세요.">
                    <p class="is-invalid-text">{{ errors.first('tax_email') }}</p>
                  </div>
                </div>
                <div class="form-group margin-bottom-24">
                  <div class="col-xs-12">
                    <label>사업분야</label>
                  </div>
                  <div class="col-xs-12">
                    <input type="text" class="hz-input-default hz-input-lg" readonly="true"
                           v-model="data['category']" placeholder="사업분야를 선택해주세요.">
                    <div class="margin-top-8">
                      <div class="checkbox" v-for="category in categoryList">
                        <label>
                          <input type="checkbox" :value="category.value" v-model="data.category">
                          <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                          {{ category.name }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group margin-bottom-24">
                  <div class="col-xs-12">
                    <label>협력희망분야</label>
                  </div>
                  <div class="col-xs-12">
                    <input type="text" class="hz-input-default hz-input-lg" readonly="true"
                           v-model="data['interest_service']" placeholder="협력희망분야를 선택해주세요.">
                    <div class="margin-top-8">
                      <div class="checkbox" v-for="interest in interestList">
                        <label>
                          <input type="checkbox" :value="interest.value" v-model="data.interest_service">
                          <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                          {{ interest.name }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group margin-bottom-40">
                  <div class="col-xs-12">
                    <label>추천인 아이디</label>
                  </div>
                  <div class="col-xs-12">
                    <input type="text"
                           class="hz-input-default hz-input-lg"
                           maxlength="50"
                           v-model="data['recommender']"
                           placeholder="추천인 아이디를 입력해주세요.">
                    <p class="explain-text">추천한 아이디를 입력하면 해당 회원사에 1개월 무료 쿠폰이 지급됩니다.</p>
                  </div>
                </div>
                <div>
                  <div class="checkbox">
                    <label class="all">
                      <input type="checkbox" v-model="data.agree_all" @change="checkAgreeAll">
                      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                      전체동의
                    </label>
                  </div>
                </div>
                <div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="data.agree_terms" @change="checkAgree()">
                      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                      [필수] <a href="https://biz.haezoom.com/media/terms/bizhaezoom_terms_2020.pdf" target="_blank"><u>이용약관</u></a> 및 <a :href="baseUrl + '/privacy/'" target="_blank"><u>개인정보 취급방침</u></a> 동의
                    </label>
                  </div>
                </div>
                <div class="margin-bottom-40">
                  <div class="checkbox sub-check-agree">
                    <label>
                      <input type="checkbox" v-model="data.agree_promotion" @change="checkAgree()">
                      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                      [선택] <span v-if="data.name">{{ data.name }}에서 </span>필요한 맞춤형 프로모션 정보를 받아보세요!
                    </label>
                  </div>
                </div>
              </div>
              <div class="register-footer col-xs-12 text-center margin-bottom-40">
                <button v-if="!isFirstForm"
                        type="button"
                        class="hz-btn-default hz-btn-lg"
                        style="border-color: #39496b; background-color: #ffffff;"
                        :disabled="isSending"
                        @click="toPreviousForm"
                >
                  이전
                </button>
                <button type="submit" class="hz-btn-primary hz-btn-lg" :disabled="isSending">{{ btnName }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <loader v-if="isLoader"></loader>
    <!-- 알림창 -->
    <modal ref="notifyModal" :id="notifyModal.id" :type="notifyModal.type" :title="notifyModal.title"
           :size="notifyModal.size" :fields="notifyModal.fields"></modal>
    <!-- 가입실패 알림 -->
    <modal ref="failModal" :id="failModal.id" :type="failModal.type" :title="failModal.title"
           :size="failModal.size" :fields="failModal.fields" @submit="$router.push({name: 'cscenter'})"></modal>
    <!-- 가입완료 알림 -->
    <modal ref="registerModal" :id="registerModal.id" :type="registerModal.type" :title="registerModal.title"
           :size="registerModal.size" :fields="registerModal.fields"></modal>
  </div>
</template>
<script>
  import Loader from 'common/components/Loader'
  import InputField from 'common/components/InputText'
  import InputPhone from 'common/components/InputPhone'
  import InputFile from 'common/components/InputFile'
  import InputAddress from 'common/components/InputAddress'
  import Modal from 'common/components/Modal'
  import api from '@/api/user'

  export default {
    name: 'register',
    components: {
      Loader,
      InputField,
      InputPhone,
      InputFile,
      InputAddress,
      Modal
    },
    data () {
      return {
        isFirstForm: true,
        isDuplicatedId: false,
        isDuplicatedCrn: false,
        isSending: false,
        isLoader: false,
        baseUrl: location.protocol + '//' + location.hostname,
        iconPresent: require('../assets/svg/ic-present.svg'),
        data: {
          username: '',
          password: '',
          password2: '',
          pic_name: '',
          pic_contact: '',
          pic_email: '',
          crn: '',
          license_file: [],
          name: '',
          address: '',
          rest_address: '',
          contact: '',
          fax: '',
          tax_email: '',
          electronic_license: false,
          category: [],
          interest_service: [],
          recommender: '',
          agree_all: false, // 전체 동의 플래그
          agree_terms: false, // 화면상에 약관동의 체크여부를 판단하기 위한 플래그
          agree_terms_company: true, // 이용약관 동의는 무조건 필수이므로 True 값만 가진다
          agree_terms_privacy: true, // 및개인정보취급방침 동의는 무조건 필수이므로 True 값만 가진다
          agree_promotion: false // 프로모션 동의 여부
        },
        categoryList: [
          { name: '공사(구조물)', value: '공사(구조물)' },
          { name: '공사(전기)', value: '공사(전기)' },
          { name: '인허가', value: '인허가' },
          { name: '제조(모듈)', value: '제조(모듈)' },
          { name: '제조(인버터)', value: '제조(인버터)' },
          { name: '제조(수배전반)', value: '제조(수배전반)' },
          { name: '기타', value: '기타' }
        ],
        interestList: [
          { name: '사업개발', value: '사업개발' },
          { name: '주택시공', value: '주택시공' },
          { name: '아파트시공', value: '아파트시공' },
          { name: 'RPS시공', value: 'RPS시공' },
          { name: '영업', value: '영업' },
          { name: '모듈/인버터구입', value: '모듈/인버터구입' },
          { name: '제안서제작', value: '제안서제작' },
          { name: '금융', value: '금융' },
          { name: '기타', value: '기타' }
        ],
        fileUploadOption: {
          validation: {
            allowedExtensions: ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,
            minFileSize: 0
          }
        },
        fileSaveUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/company/file/',
        fileRemoveUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/company/file/delete/',
        notifyModal: {
          id: 'notifyModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [''],
              class: 'text-center'
            }
          ]
        },
        registerModal: {
          id: 'registerModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['회원가입이 완료되었습니다.', '로그인 페이지로 이동합니다.'],
              class: 'text-center'
            }
          ]
        },
        failModal: {
          id: 'failModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['회원가입에 실패하였습니다.', '문의 페이지로 이동하시겠습니까?'],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      btnName () {
        return this.isFirstForm ? '다음' : '가입'
      }
    },
    watch: {
      'data.username': {
        handler () {
          if (this.isDuplicatedId) {
            this.isDuplicatedId = false
          }
        }
      },
      'data.crn': {
        handler () {
          if (this.isDuplicatedCrn) {
            this.isDuplicatedCrn = false
          }
        }
      }
    },
    methods: {
      checkAgree () {
        this.data.agree_all = this.data.agree_terms && this.data.agree_promotion
      },
      checkAgreeAll () {
        const isCheckedAll = this.data.agree_all
        this.data.agree_terms = isCheckedAll
        this.data.agree_promotion = isCheckedAll
      },
      checkDuplicateAccount () {
        const data = _.cloneDeep(this.data)

        this.isSending = true

        // 아이디, 사업자등록번호 중복등록 여부
        api.checkNextStep(data, response => {
          if (response.error) {
            this.isSending = false
            this.showToastMessage('인증실패')
          } else {
            // 아이디 또는 사업자등록번호가 중복일 경우 알림창을 띄운다.
            if (response.code === 'VD') {
              const message = response.message
              if (message.includes('ID')) {
                this.isDuplicatedId = true
              } else {
                this.isDuplicatedCrn = true
              }
              this.$nextTick(() => {
                this.notifyModal.fields[0].message = [message]
                this.$refs.notifyModal.show()
                this.scrollToErrorField()
              })
            } else {
              this.isFirstForm = false
              window.scrollTo(0, 0)
            }

            this.isSending = false
          }
        })
      },
      validateCompanyRegistrationNumber () {
        // 사업자 등록번호 양식에 유효한지 검사한다.
        const crn = this.data.crn
        const bisNo = crn.replace(/-/gi, '')
        const checkIds = [1, 3, 7, 1, 3, 7, 1, 3, 5, 1]
        let chkSum = 0
        let c2 = '0'
        let remander

        for (let i = 0; i <= 7; i++) {
          chkSum += checkIds[i] * bisNo.charAt(i)
        }

        c2 += (checkIds[8] * bisNo.charAt(8))
        c2 = c2.substring(c2.length - 2, c2.length)

        chkSum += Math.floor(c2.charAt(0)) + Math.floor(c2.charAt(1))

        remander = (10 - (chkSum % 10)) % 10

        return Math.floor(bisNo.charAt(9)) === remander
      },
      onSubmit () {
        const firstFormVlidate = ['id', 'password', 'password2', 'name', 'contact', 'email', 'crn']
        const secondFormValidate = ['company', 'address', 'company_contact']
        const validateList = this.isFirstForm ? firstFormVlidate : secondFormValidate

        for (let target of validateList) {
          this.$validator.validate(target)
        }

        this.$nextTick(() => {
          if (this.errors.any()) {
            this.scrollToErrorField()
            return false
          }

          // 첫번째 입력폼일 경우, 사업자 등록번호 유효성 검증 및 유저 중복 여부를 확인한다.
          if (this.isFirstForm) {
            if (this.validateCompanyRegistrationNumber()) {
              this.checkDuplicateAccount()
            } else {
              this.notifyModal.fields[0].message = ['사업자 등록번호를 다시 확인해주세요.']
              this.$refs.notifyModal.show()
            }
          } else {
            this.register()
          }
        })
      },
      register () {
        const data = _.cloneDeep(this.data)

        // 필수 약관체크 확인
        if (!data.agree_terms) {
          this.notifyModal.fields[0].message = ['이용약관 및 개인정보취급방침 동의는 필수입니다.']
          this.$refs.notifyModal.show()
          return false
        }

        // 2단계 기업정보 입력 일 경우
        data.license_file = JSON.stringify(data.license_file)
        data.category = data.category.toString()
        data.interest_service = data.interest_service.toString()

        this.isLoader = true

        // 회원가입 API 실행
        api.registUser(data, response => {
          if (response.error) {
            // 가입실패 시 고객문의 페이지로 이동여부를 묻는 알림창을 띄운다.
            this.isLoader = false
            this.$refs.failModal.show()
          } else {
            this.isLoader = false

            // 구글 태그매니저 회원가입 완료 트래킹을 위한 queryset 설정
            this.$router.push({query: {'signup': 'done'}})

            // 가입이 완료되었을 경우, 가입완료 알림을 띄운다.
            this.$refs.registerModal.show()

            // 알림창이 닫히면 로그인 페이지로 이동한다.
            $('#registerModal').on('hidden.bs.modal', () => {
              this.$router.push({name: 'login'})
            })
          }
        })
      },
      scrollToErrorField: _.debounce(() => {
        $('html, body').stop().animate({
          scrollTop: $('.form-group .is-invalid').first().offset().top - 112
        }, 500)
      }, 100),
      toPreviousForm () {
        this.isFirstForm = true
        this.errors.clear()
        window.scrollTo(0, 0)
      }
    },
    created () {
      // 유효힌 토큰을 들고 있을 경우, 로그인한 유저라 판단하고 redirect
      const token = localStorage.getItem('_t')
      if (token) {
        this.$store.dispatch('inspectToken', token).then(() => {
          this.$router.push({name: 'index'})
        })
      }
    },
    mounted () {
      this.$refs.inputId.focus()
    },
    beforeDestroy () {
      kendo.destroy(document.body)
    }
  }
</script>

<style lang="scss" scoped>
  #register {
    .container {
      padding: 0 16px;
    }

    #registerBenefit {
      padding: 96px 0 40px;

      @media (max-width: $screen-xs-max) {
        padding: 48px 0 40px;
      }

      .title {
        margin: 0 0 16px;
        font-size: 32px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: -1.3px;
        text-align: center;
        color: $font-color;
      }

      .description {
        margin: 0 0 32px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: -0.8px;
        text-align: center;
        color: #5d656e;
      }

      .benefit-list {
        margin: 0 0 24px;
        padding: 0;
        overflow: hidden;
        list-style: none;

        li {
          width: 25%;
          float: left;
        }

        .number {
          margin: 0 auto 16px;
          width: 33px;
          height: 21px;
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: -0.35px;
          text-align: center;
          color: #5f78a4;
          border-radius: 10.5px;
          background-color: #ccd4e9;
        }

        .desc {
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: -0.35px;
          text-align: center;
          color: $font-color;
        }
      }

      .benefit-box {
        display: table;
        width: 100%;
        padding: 10px 24px;
        border-radius: 7px;
        background-color: #ccd4e9;

        object, p {
          display: table-cell;
          vertical-align: middle;
        }

        object {
          margin: 6px 24px 0 0;
        }

        p {
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: -0.35px;
          color: #333f58;
        }
      }
    }

    #registerForm {
      padding: 40px 0 96px;
      background-color: $hzc-gray-01;

      @media (max-width: $screen-xs-max) {
        padding: 40px 0 48px;
      }

      .col-xs-12 {
        padding: 0;
      }

      .form-group {
        width: 100%;
        overflow: hidden;
        margin-bottom: 8px;

        .col-xs-12 {
          padding: 0;

          >label {
            margin: 0;
            font-size: 14px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 32px;
            letter-spacing: -0.8px;
            text-align: left;
            color: $font-color;
          }

          >input {
            width: 100%;
          }

          .hz-radio-btn {
            line-height: initial;
            font-weight: 400;
            color: #495057;
          }
        }
      }

      .checkbox {
        display: inline-block;
        margin: 0 16px 8px 0;

        label,
        label a {
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.57;
          letter-spacing: -0.58px;
          color: #9199a1;
        }

        label.all {
          font-weight: bold;
          color: $font-color;
        }

        .cr {
          width: 20px;
          height: 20px;
          margin: 1px 6px 0 0;
        }

        .cr-icon {
          font-size: 12px;
        }
      }

      .is-invalid-text a {
        margin: 0 0 0 4px;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: -0.3px;
        text-decoration: underline;
        color: $font-color;
      }

      .explain-text {
        margin: 4px 0 0;
      }

      .register-footer {
        button {
          width: 140px;
          @media (max-width: 991px) {
            width: 100%;
          }
        }
        .hz-btn-default {
          margin-right: 16px;
          @media (max-width: 991px) {
            margin: 0 0 8px 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue